import { useCallback } from 'react';

import { PcfraStatus, UpdatePcfraStatusPayload } from '~/common/types/people';
import { getFullPcfraStatusComment } from '~/common/utils/people';

import { useCurrentUser, useUserStore } from './storeSelectorHooks';

type UpdatePcfraStatusParams = Omit<UpdatePcfraStatusPayload, 'comments'>;

export const useUpdatePcfraStatus = () => {
  const user = useCurrentUser();

  const userStore = useUserStore();

  return useCallback(
    ({ propertyId, personId, newStatus, note, shouldNotifyReferrer }: UpdatePcfraStatusParams) => {
      if (!user || !userStore) {
        return;
      }
      const prevStatus = userStore.get('pcfraPeople', personId)?.pcfraStatus ?? PcfraStatus.None;

      userStore.handleAndDispatchMessage('updatePcfraStatus', personId, {
        propertyId,
        personId,
        newStatus,
        note,
        shouldNotifyReferrer,
        comments: getFullPcfraStatusComment(prevStatus, newStatus, user),
      });
    },
    [user, userStore],
  );
};
